import { useColorModeValue } from '@chakra-ui/react';

export default function useColors() {
  return {
    text: {
      'default': useColorModeValue('gray.600', 'gray.400'),
      active: 'link_accent',
      hover: 'link_hovered',
    },
    bg: {
      'default': 'transparent',
      active: 'surface_muted',
    },
    border: {
      'default': 'divider',
      active: 'surface_muted',
    },
  };
}
